import { render, staticRenderFns } from "./shopLogin.vue?vue&type=template&id=22f41063&scoped=true"
import script from "./shopLogin.vue?vue&type=script&lang=js"
export * from "./shopLogin.vue?vue&type=script&lang=js"
import style0 from "./shopLogin.vue?vue&type=style&index=0&id=22f41063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f41063",
  null
  
)

export default component.exports